module.exports = __webpack_public_path__ + "img/ctrl-ising-dagger-stub-0.946f303b.svg";